<!-- 统计分析组件 -->
 <template>
   <!-- <div class="analyWrap analyWrapFlex"> -->
      <!-- <div v-for="(item,index) in analyData" :key="index" class="analyWrapChild analyWrapFlex" >
         <div class="imgMarkWrap" >
            <img :style="{'height':item.height?item.height:'48px','width':item.width?item.width:'48px'}" class="imgMark" :src='item.imgMark' />
            <img  :src="'/bsp-com/static/icon/' + appCode + '/' + item.code + '.' + item.file_extension" style="width: 50px; margin: auto" alt="暂未发布" />

        </div>
         <div>
             <p>{{ item.title }}</p>
             <span :style="{'color':item.color?item.color:'green',}" class="num">{{ item.num }}</span>
         </div>
      </div> -->
      <div class="analyWrapChild analyWrapFlex" @click="oprate" :style="{'height':formValidate.height?formValidate.height:'60px','width':formValidate.width?formValidate.width:'200px'}" >
        <div class="imgMarkWrap" >
            <img v-if="formValidate.icon" :style="{'height':formValidate.heightImg?formValidate.heightImg:'48px','width':formValidate.widthImg?formValidate.widthImg:'48px'}" class="imgMark" :src='formValidate.icon' />
            <img v-if="formValidate.iconMark && formValidate.iconMark.indexOf('^custom^')>-1" :src="'/bsp-com/static/icon/' + appCode + '/' + formValidate.iconMark.replace('^custom^','')" style="width: 50px; margin: auto" alt="暂未发布" />
            <Icon :type="formValidate.iconMark" v-else :size="48" :color="formValidate.color?formValidate.color:'#23ade5'" />
        </div>
        <div>
             <p class="title">{{ formValidate.name }}</p>
             <span :style="{'color':formValidate.color?formValidate.color:'#23ade5',}" class="num" >{{ formValidate.value?formValidate.value:0}}</span>
         </div>
      </div>
   <!-- </div> -->
 </template>
 
 <script>
import { mapActions } from 'vuex'

 export default {
    props:{
        mark:String
    },
    data(){
        return{
            // analyData:[
            //     {title:'今日待处理',num:45,color:'#02bcc4',imgMark:require('@/assets/analy/icon_appointment.png'),oprateType:1,path:'',width:'48px',height:'48px',code: "processManagement",file_extension: "png"},
            //     {title:'今日已处理',num:2,color:'#f99e2d',imgMark:require('@/assets/analy/icon_appointment.png'),oprateType:0,path:'',width:'48px',height:'48px',code: "processManagement",file_extension: "png"},
            //     {title:'预约人数',num:12,color:'#fe4e4e',imgMark:require('@/assets/analy/icon_appointment.png'),oprateType:0,path:'',width:'48px',height:'48px',code: "processManagement",file_extension: "png"},
            //     {title:'今日无需处理',num:108,color:'#23ade5',imgMark:require('@/assets/analy/icon_appointment.png'),oprateType:0,path:'',width:'48px',height:'48px',code: "processManagement",file_extension: "png"}, 
            // ],
            appCode:serverConfig.APP_CODE,
            formValidate:{}
        }
    },
    methods:{
        ...mapActions(['postRequest', 'authGetRequest','authPostRequest']),
        getDataByid () {
            //  this.$path.com_getByMark_url
            this.postRequest({ url:'/bsp-uac/com/card/getByMark',params: {mark:this.mark} }).then(data => {
            if (data.success) {
                this.formValidate=data.data
                this.getMultiQuery(this.formValidate.queryMark) 
            
    
            } else {
                this.$Notice.error({
                title: '错误提示',
                desc: data.msg
                })
            }
            })
      },
      getMultiQuery(mark) {
      let query = Object.assign({mark:mark}, this.$route.query)
      //this.$path.com_executeMultiQuery_url
      this.$store.dispatch('postRequest', { url:'/bsp-uac/com/form/handle/executeMultiQuery' , params: query }).then(resp => {
        if (resp.success) {
            if(resp.data && resp.data.length>0){
                Object.assign(this.formValidate, resp.data[0])
                this.$forceUpdate();
            }
        } else {
        }
      })
    },
    oprate(){
        if(this.formValidate.triggerType=='02'){
            
        }else if(this.formValidate.triggerType=='03'){
            this.formValidate.url?window.open(this.formValidate.url,'_blank'):''
        }
    }
    },
    mounted(){
        this.getDataByid ()
    }
 }
 </script>
 
 <style lang="less">
 .analyWrap{
    justify-content: space-around;
    padding: 16px 16px 16px 0;
    border-right:1px solid #e8eef0;
 }
 .analyWrapChild{
    border-right:1px solid #e8eef0;
    cursor: pointer;
 }
//  .analyWrapChild:first-of-type{
//     border-left:none;
//  }
 .analyWrapFlex{
    display: flex;
    align-items: center;
    // margin-bottom: 16px;
    background: #fff;
    border-radius: 4px;
    .imgMarkWrap{
        width: 68px;
        height: 68px;
        text-align: center;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        margin:0 16px;
    }
    .title{
        color: #616f6f;
        font-size: 16px;
    }
    .num{
        line-height: 40px;
        font-weight: 700;
        font-size: 30px;
        height: 40px;
    }
 }
 </style>


// WEBPACK FOOTER //
// src/component/statistical-analysis/index.vue